<template>
  <div class="notes-evaluation">
    <Evaluation
      :condition="condition"
      :pagination="pagination"
      :tableData="tableData"
      @updateData="_updateData"
    />
  </div>
</template>
<script>
import updateData from 'mixins/updateData'
import Evaluation from '../Component/'

export default {
  name: 'notesEvaluation',
  components: {
    Evaluation
  },
  mixins: [updateData],
  data() {
    this.keyMap = {
      notes_list: {
        name: 'tableData',
        member_avatar: 'avatar',
        member_name: 'name',
        add_time: 'notesTime',
        note_id: 'id',
        member_id: 'vipId',
        note_image: 'img',
        picture_url: 'url',
        goods_name: 'cnName',
        goods_en: 'enName',
        is_top: 'isTop',
        note_scores: 'score',
        note_content: 'notesContent',
        note_like_number: 'likeNum',
        note_reply_number: 'replyNum',
        note_status: 'isAnonymous'
      }
    }
    return {
      condition: {},
      pagination: {},
      tableData: []
    }
  },
  created() {
    this._getNotesList({
      curpage: 1
    })
  },
  methods: {
    /**
     * 获取笔记列表
     * @param params
     * @private
     */
    _getNotesList(params) {
      this.api.getNotesList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    }
  }
}
</script>
